import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Lazy load
 * @link https://greensock.com/docs/v3/Plugins/ScrollTrigger
 */

export function initLazyLoad() {

    ScrollTrigger.config({ limitCallbacks: true });

    // Variables ------------------------------------------------------------------ //

    const images = gsap.utils.toArray('.lazyImg');

    // Functions ------------------------------------------------------------------ //

    // Iterators ------------------------------------------------------------------ //

    images.forEach((image) => {
        const newSRC = image.dataset.src,
            newImage = document.createElement('img'),
            loadImage = () => {
                newImage.onload = () => {
                    newImage.onload = null; // avoid recursion
                    newImage.src = image.src; // swap the src
                    image.src = newSRC;
                    // place the low-res version on TOP and then fade it out.
                    gsap.set(newImage, {
                        position: 'absolute',
                        top: image.offsetTop,
                        left: image.offsetLeft,
                        width: image.offsetWidth,
                        height: image.offsetHeight,
                        filter: 'blur(15px)',
                        scale: 1.05
                    });
                    image.parentNode.appendChild(newImage);
                    gsap.to(newImage, {
                        opacity: 0,
                        scale: 1,
                        filter: 'blur(0)',
                        delay: 0.2,
                        onStart: () => {
                            image.classList.add('loaded');
                        },
                        onComplete: () => {
                            newImage.parentNode.removeChild(newImage);
                            image.removeAttribute('data-src'); // remove "data-src" attribute if image is loaded
                        }
                    });
                    st && st.kill();
                };
                newImage.src = newSRC;
            },
            st = ScrollTrigger.create({
                trigger: image,
                start: '-50% bottom',
                onEnter: loadImage,
                onEnterBack: loadImage // make sure it works in either direction
            });
    });
}
